// This file was automatically generated from service.status.html.
// Please don't edit this file by hand.

goog.provide('el8.template.service.status');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.service.status.connectionAlertContainer = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span id="network-status"><div class="alertNoInternet text-section"></div></span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.service.status.noInternetText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Internet connection has been lost. Any information that you add will not be saved. Please restore the internet connection before adding more information to the patient record.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.service.status.serverErrorText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Cannot reliably communicate with the Elation server. Please contact Support before adding more information to the patient record.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.service.status.internetRestoredAlert = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="alertInternetRestored">Internet connection has been restored! You can resume normal use of the patient record.</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.service.status.supportMessageAlert = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span id="support-msg-container"><div class="alertSupportMessage"><a class="dismiss-trigger removeNotifier"></a><span class="support-msg">', opt_data.msg, '</span></div></span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.service.status.websocketConnectionAlert = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span id="websocket-status"><div class="warningNoWebSocket text-section">Cannot reliably communicate with the Elation realtime server. You can continue to work with the EMR, but you will not see any realtime updates.</div></span>');
  if (!opt_sb) return output.toString();
};
